import ObjectModel from 'cio/models/object';
import ObjectTypeModel from 'cio/models/object-type';
import RelationshipModel from 'cio/models/relationship';

type ObjectPreviewVariablesMap = Record<string, ObjectModel['attributes'][]>;

export default function getObjectPreviewVariables(
  objects?: ObjectModel[],
  customerId?: string,
): ObjectPreviewVariablesMap {
  if (objects == null) {
    return {};
  }

  return objects.reduce<ObjectPreviewVariablesMap>((acc, object) => {
    let objectType = object.belongsTo('objectType').value() as ObjectTypeModel | null;
    let relationships = object.hasMany('relationships').value() as RelationshipModel[] | null;
    if (objectType == null || !objectType.enabled) {
      return acc;
    }
    let { slug } = objectType;
    if (acc[slug] == null) {
      acc[slug] = [];
    }

    let relationshipAttributes =
      Array.from(relationships ?? []).reduce((acc, rel) => {
        let relatedCustomerId = rel.belongsTo('customer').id();
        if (relatedCustomerId === customerId) {
          return { ...acc, ...rel.attributes };
        }

        return acc;
      }, {}) ?? {};

    let item = {
      ...object.attributes,
      ...(Object.keys(relationshipAttributes).length > 0 && { relationship: relationshipAttributes }),
    };

    acc[slug] = [...acc[slug], { ...item }];
    return acc;
  }, {});
}
